import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import page from '../../../assets/images/accessDenied.svg';
import { buttonStyle2 } from '../../../utils/commonStyle';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

export default function AccessDenied() {
  const theme = useTheme();
  const { t } = useTranslation();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  return (
    <Stack
      flex={1}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <img
        src={page}
        width={'234px'}
        height={'234px'}
      />
      <Typography
        className="fw-bold ff-Roboto fs-20 !mt-[20px]"
        color={text}
      >
        {/* OOPS! */}
      </Typography>
      <Typography
        className="fw-regular ff-Roboto fs-14 !mt-[10px] !mb-[15px]"
        color={'#414141'}
      >
        You don’t have permission to view this module. Contact your admin
      </Typography>
      {/* <Button
        sx={[
          buttonStyle2,
          {
            color: theme.palette.background.main,
            backgroundColor: theme.palette.primary.dark,
            textTransform: 'uppercase',
            '&:hover': {
              // backgroundColor: theme.palette.secondary.main,
              // color: theme.palette.background.main,
            },
          },
        ]}
        style={{ width: '208px', height: '40px' }}
        variant="contained"
      >
        {t('Back to dashboard')}
      </Button> */}
    </Stack>
  );
}
